import React, { useCallback, useEffect } from 'react'
import { ConfirmationField, Heading, Spacer, Text, theme } from '@mtsdengi/ui-kit'
import { MetricsEvent, MetricsEventsEnum, useMetrics } from '@shared/utils'

/**
 * @prop isLoading -
 * @prop isDisabled -
 * @prop hasError -
 * @prop onChangePhone -
 * @prop onSendCode -
 * @prop onComplete -
 */
export type ConfirmationSmsCodeFormProps = {
  phoneNumber: string
  isLoading: boolean
  isDisabled: boolean
  hasError: boolean
  errorMessage: string
  onChangePhone: () => void
  onSendCode: () => void
  onComplete: (code: string) => void
}

export const ConfirmationSmsCodeForm = ({
  phoneNumber,
  isLoading,
  isDisabled,
  hasError,
  errorMessage,
  onChangePhone,
  onSendCode,
  onComplete,
}: ConfirmationSmsCodeFormProps) => {
  useEffect(() => {
    onSendCode()
  }, [onSendCode])

  const sendEventData = useMetrics()
  const handleComplete = useCallback(
    (code: string) => {
      onComplete(code)
      sendEventData({
        label: 'kod_iz_sms',
        event: MetricsEventsEnum.VALIDATE_SUCCESS_FIELD,
      })
    },
    [sendEventData, onComplete]
  )

  return (
    <MetricsEvent.Show conversions success label="anketa_contact">
      <Heading>Подтвердите номер телефона</Heading>
      <Spacer space={theme.spacings.xs3} />
      <Text>Код подтверждения отправлен на номер {phoneNumber}</Text>
      <Spacer space={theme.spacings.sm} />
      <ConfirmationField
        autoFocus
        topText="Код из СМС"
        isLoading={isLoading}
        isDisabled={isDisabled}
        onChangePhoneClick={onChangePhone}
        onSendCodeClick={onSendCode}
        onComplete={handleComplete}
        hasError={hasError}
        errorMessage={errorMessage}
      />
    </MetricsEvent.Show>
  )
}
